import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var bodyStyle = 'fx_2d2fb1e5_1kkjbsh9';
var contentInnerStyle = 'fx_2d2fb1e5_1kkjbsh8';
var contentPositionerStyle = 'fx_2d2fb1e5_1kkjbsh4';
var contentStyle = 'fx_2d2fb1e5_1kkjbsh7';
var descriptionStyle = 'fx_2d2fb1e5_1kkjbshb';
var fogStyle = 'fx_2d2fb1e5_1kkjbsh1';
var footerStyle = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1kkjbshc',variantClassNames:{orientation:{vertical:'fx_2d2fb1e5_1kkjbshd',horizontal:'fx_2d2fb1e5_1kkjbshe'}},defaultVariants:{},compoundVariants:[]});
var portalContainerStyle = 'fx_2d2fb1e5_1kkjbshf';
var scrollAreaViewportStyle = 'fx_2d2fb1e5_1kkjbsh0';
var titleStyle = 'fx_2d2fb1e5_1kkjbsha';

export { bodyStyle, contentInnerStyle, contentPositionerStyle, contentStyle, descriptionStyle, fogStyle, footerStyle, portalContainerStyle, scrollAreaViewportStyle, titleStyle };
//# sourceMappingURL=dialog.vanilla.mjs.map
